module.exports = __webpack_public_path__ + "static/media/slackers-who-slack.bff41048.png";